function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", {
  id: "defs6"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    viewBox: "0 0 682.66669 634.81598",
    height: 634.81598,
    width: 682.66669,
    xmlSpace: "preserve",
    id: "svg2",
    version: 1.1
  }, props), _ref, React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,634.816)",
    id: "g10"
  }, React.createElement("g", {
    transform: "translate(358.7616,476.1117)",
    id: "g12"
  }, React.createElement("path", {
    id: "path14",
    style: {
      "fill": "currentColor",
      "fillOpacity": 1,
      "fillRule": "nonzero",
      "stroke": "none"
    },
    d: "m 0,0 -7.534,-11.49 -88.145,-8.507 -114.972,-52.162 101.971,-6.761 83.284,40.193 -27.366,-41.73 -85.929,-57.986 -107.1,-46.148 -67.337,-68.486 46.175,-15.181 v 0.003 l -15.912,-62.912 -75.897,-144.945 166.238,125.121 44.432,71.393 62.819,59.093 h 10e-4 v 0.001 l 82.354,62.129 156.156,48.827 -138.597,19.572 50.988,23.563 -0.002,0.004 0.002,-0.003 20.483,32.935 z"
  }))));
};

export default __webpack_public_path__ + "static/media/logo.93698af2.svg";
export { SvgComponent as ReactComponent };